import { H4, H5, Image } from 'AbstractElements';
import { Col, Card, Button, Table, Modal, ModalBody, ModalHeader, Media } from 'reactstrap';
import React, { Fragment, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import PaginationComponent from 'Component/Common/PaginationComponent';
import { setFilters } from 'Services/Features/User/userSlice';
import { getLoyalty } from 'Services/Features/Loyalty/Utils/loyaltyUtils';
import {
    handleNextPagination,
    handleBackPagination,
    handleClickPagination
} from 'Component/DashboardQeza/Common/PaginationUtils';
import user1 from 'assets/images/user/1.jpg';
import CustomLoader from 'Component/Common/CustomLoader';
import CurrencyFormatter from 'Component/Common/Formatter/CurrencyFormatter';

const TreatmentTable = ({ setRefetch }) => {
    const users = useSelector((state) => state.user.users);
    const loading = useSelector((state) => state.user.loading);
    const loadingLoyalty = useSelector((state) => state.loyalty.loading);
    const loyalties = useSelector((state) => state.loyalty.loyalties);
    const pagination = useSelector((state) => state.user.pagination);
    const filters = useSelector(state => state.user.filters);
    const dispatch = useDispatch();
    const [selectedImage, setSelectedImage] = useState(null);
    const [selectedUser, setSelectedUser] = useState(null);
    const [modalOpen, setModalOpen] = useState(false);
    const toggleModal = () => setModalOpen(!modalOpen);

    const handleImageClick = (src) => {
        setSelectedImage(src);
        setModalOpen(true);
    };
    const toggleModalTreatment = (item) => {
        setSelectedUser(item);
        dispatch(getLoyalty({ "filter[user.email]": item.email }));
        setModalTreatment(!modalTreatment);
    };
    const [modalTreatment, setModalTreatment] = useState(false);
    return (
        <Fragment>
            <Modal isOpen={modalOpen} toggle={toggleModal} centered size="lg">
                <ModalBody className="text-center">
                    <img src={selectedImage} alt="Preview" style={{ maxWidth: '100%', maxHeight: '80vh' }} />
                </ModalBody>
            </Modal>
            <Modal isOpen={modalTreatment} toggle={toggleModalTreatment} centered size="lg">
                <ModalHeader className="bg-primary">
                    <H4>{`Riwayat Poin : ${selectedUser?.name} (${selectedUser?.email})`}</H4>
                </ModalHeader>
                <ModalBody className="text-center">
                    {loadingLoyalty ? (
                        <CustomLoader />
                    ) : loadingLoyalty === false && loyalties.length === 0 ? (
                        <Col md="12">
                            <div className="no-data-found d-flex flex-column align-items-center justify-content-center" style={{ height: '300px' }}>
                                <i className="fa fa-search" style={{ fontSize: '100px', color: '#ccc', marginBottom: '20px' }}></i>
                                <H4>User Tidak Memiliki Poin</H4>
                            </div>
                        </Col>
                    ) : (
                        <div className="table-responsive">
                            <Table className=" table-hover">
                                <thead className="bg-primary">
                                    <tr>
                                        <th scope="col" style={{ width: '15px' }}>{'#'}</th>
                                        <th scope="col" style={{ whiteSpace: 'nowrap', overflow: 'hidden' }}>{'Jumlah'}</th>
                                        <th scope="col">{'Total Poin'}</th>
                                        <th scope="col">{'Level'}</th>
                                        <th scope="col">{'ID Transaksi'}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        loyalties && loyalties.map((item, i) =>
                                            <tr key={item.id}>
                                                <th scope="row" style={{ verticalAlign: "top" }}>{i + 1}</th>
                                                <td><H5>{item.amount}</H5></td>
                                                <td><H5>{item.total_point}</H5></td>
                                                <td><H5>{item.level}</H5></td>
                                                <td><H5>{item.order_id}</H5></td>
                                            </tr>
                                        )
                                    }
                                </tbody>
                            </Table>
                        </div>
                    )
                    }
                </ModalBody>
            </Modal>
            <Col sm="12" lg="12" xl="12">
                <Card>
                    <div className="mb-5">
                        <Col sm="12" lg="12" xl="12">
                            <div className="table-responsive">
                                <Table className=" table-hover">
                                    <thead className="bg-primary">
                                        <tr>
                                            <th scope="col" className="sticky-col-number" style={{ width: '15px' }}>{'#'}</th>
                                            <th scope="col" className="sticky-col-name" style={{ whiteSpace: 'nowrap', overflow: 'hidden' }}>{'Nama'}</th>
                                            <th scope="col">{'Kontak'}</th>
                                            <th scope="col" className="text-center">{'Poin'}</th>
                                            <th scope="col"><span title="Total order dalam 3 bulan terakhir">{'Total Order'}</span></th>
                                            <th scope="col">{'Order Terakhir'}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            users && users.map((item, i) =>
                                                <tr key={item.id}>
                                                    <th className="sticky-col-number" scope="row" style={{ verticalAlign: "top" }}>{i + 1}</th>
                                                    <td className="sticky-col-name">
                                                        <Media>
                                                            <div className="me-2">
                                                                <Image
                                                                    attrImage={{
                                                                        className: 'b-r-5',
                                                                        style: { width: '60px', height: '60px', objectFit: 'cover', cursor: 'pointer' },
                                                                        src: `${item.profile_pictures_path ? item.profile_pictures_path : user1}`,
                                                                        alt: `${item.name}`,
                                                                        onClick: () => handleImageClick(item.profile_pictures_path ? item.profile_pictures_path : user1)
                                                                    }}
                                                                />
                                                            </div>
                                                            <Media body className="ps-2">
                                                                <div>
                                                                    <H5>
                                                                        {item.name}
                                                                        {item.verified_at && (
                                                                            <span style={{ color: 'green', marginLeft: '10px' }} title={`Verified at: ${item.verified_at}`}><i class="icofont icofont-check-circled"></i></span>
                                                                        )}
                                                                    </H5>
                                                                    <code>{item.dob}</code>
                                                                </div>
                                                            </Media>
                                                        </Media>
                                                    </td>
                                                    <td><H5>{item.email}</H5><code>{item.phone}</code></td>
                                                    <td className="text-center">
                                                        <Button
                                                            title="Detail Poin"
                                                            className="btn btn-warning btn-sm mb-1 mx-1"
                                                            onClick={() => { toggleModalTreatment(item) }}
                                                        >
                                                            <i className="fa fa-trophy"></i> {` ${item.points} poin`}
                                                        </Button>
                                                    </td>
                                                    <td>
                                                        <span title="Total order dalam 3 bulan terakhir">
                                                            <CurrencyFormatter amount={item.total_sales_3_month} />
                                                        </span>
                                                    </td>
                                                    <td>
                                                        <CurrencyFormatter amount={item.latest_sales} />
                                                    </td>
                                                </tr>
                                            )
                                        }
                                    </tbody>
                                </Table>
                            </div>
                            <div style={{ marginTop: '100px', display: 'flex', justifyContent: 'center' }}>
                                {loading === false && users && users.length > 0 && (
                                    <PaginationComponent
                                        pagination={pagination}
                                        handleBackPagination={() => handleBackPagination(pagination, filters, dispatch, setFilters, setRefetch)}
                                        handleClickPagination={(page) => handleClickPagination(page, filters, dispatch, setFilters, setRefetch)}
                                        handleNextPagination={() => handleNextPagination(pagination, filters, dispatch, setFilters, setRefetch)}
                                    />
                                )}
                            </div>
                        </Col>
                    </div>
                </Card>
            </Col>
        </Fragment>
    );
};

export default TreatmentTable;